/**
 * 应用：
 *    1.零售新增-添加商品SKU、零售详情-添加赠品
 *    2.组合商品单对象-添加成分商品
 *    3.百分比分货策略-参与商品明细-添加商品
 */
import categoryName from 'allpages/basicData/CATEGORY_NAME.vue';
export default {
  components: {
    categoryName
  },
  data() {
    return {
      loading: false,
      btnConfig: {
        typeAll: 'default', // 按钮统一风格样式
        btnsite: 'right', // 按钮位置 (right , center , left)
        buttons: [
          {
            text: t('取消'),
            btnclick: () => {
              this.$emit('on-cancel')
            } // 按钮点击事件
          },
          {
            type: 'primary',
            text: t('确定'),
            loading: false,
            btnclick: () => {
              this.submit();
            }
          }
        ]
      },
      formConfig: {
        formValue: {
          PS_C_PRO_ID: '', // SPU编码
          PS_C_PRO_ENAME: '', // SKU名称
          ECODE: '',
          PS_C_BRAND_ID: '',
          PS_C_CATEGORY_ID: '', // 商品品类
          PS_C_CATEGORY_ONE_ID: '',
          PS_C_CATEGORY_THREE_ID: '',
          IS_GIFT: '',
          IS_GROUP: 'N',
        },
        formData: [
          {
            style: 'dropSelect',
            width: '8',
            itemdata: {
              col: 2,
              colid: 136292, // 字段id
              colname: 'PS_C_PRO', // 当前字段的名称 用来显示的
              display: 'text', // 显示什么类型，例如xml表示弹窗多选加导入功能，mrp表示下拉多选
              fkdisplay: 'drp', // 外键关联类型
              fkdesc: '品牌',
              inputname: 'PS_C_PRO:ENAME', // 这个是做中文类型的模糊查询字段，例如ENAME
              isfk: true, // 是否有fk键
              isnotnull: false, // 是否必填
              name: t('SPU编码'),
              readonly: false, // 是否可编辑，对应input   readonly属性
              reftable: 'PS_C_PRO', // 对应的表
              reftableid: 23051, // 对应的表ID
              pid: '',
              statsize: -1,
              valuedata: '', // 这个是选择的值
            },
            oneObj: e => {
              this.formConfig.formValue.PS_C_PRO_ID = e.pid
            },
          },
          {
            style: 'input',
            label: t('SKU名称'),
            value: 'PS_C_PRO_ENAME',
            width: '8',
            placeholder: t('请完成输入后回车'),
            disabled: false,
            inputChange: () => {
            },
            inputenter: (val) => {
              this.request()
            }
          },
          {
            style: 'input', // 输入框类型
            label: t('商品SKU'),
            value: 'ECODE', // 输入框的值
            width: '8', // 所占的宽度 (宽度分为24份,数值代表所占份数的宽度)
            disabled: false,
            inputChange: () => {
            },
            inputenter: (val) => {
              this.request()
            }
          },
          {
            style: 'dropSelect',
            width: '8',
            itemdata: {
              col: 2,
              colid: 166758, // 字段id
              colname: 'PS_C_BRAND', // 当前字段的名称 用来显示的
              display: 'text', // 显示什么类型，例如xml表示弹窗多选加导入功能，mrp表示下拉多选
              fkdisplay: 'drp', // 外键关联类型
              fkdesc: '品牌',
              inputname: 'PS_C_BRAND:ENAME', // 这个是做中文类型的模糊查询字段，例如ENAME
              isfk: true, // 是否有fk键
              isnotnull: false, // 是否必填
              name: t('品牌'),
              readonly: false, // 是否可编辑，对应input   readonly属性
              reftable: 'PS_C_BRAND', // 对应的表
              reftableid: 23051, // 对应的表ID
              pid: '',
              statsize: -1,
              valuedata: '', // 这个是选择的值
            },
            oneObj: e => {
              this.formConfig.formValue.PS_C_BRAND_ID = e.pid
            },
          },
          {
            style: 'formCompile',
            label: t('商品品类'),
            slotName: 'formCompile',
            value: 'PS_C_CATEGORY_ID',
            width: '8',
          },
          {
            style: 'dropSelect',
            width: '8',
            itemdata: {
              col: 2,
              colid: 1700861921, // 字段id
              colname: 'PS_C_CATEGORY_ONE_ID', // 当前字段的名称 用来显示的
              display: 'text', // 显示什么类型，例如xml表示弹窗多选加导入功能，mrp表示下拉多选
              fkdisplay: 'drp', // 外键关联类型
              fkdesc: '品牌',
              inputname: 'PS_C_PRO:ENAME', // 这个是做中文类型的模糊查询字段，例如ENAME
              isfk: true, // 是否有fk键
              isnotnull: false, // 是否必填
              name: t('一级分类'),
              readonly: false, // 是否可编辑，对应input   readonly属性
              reftable: 'PS_C_PRO', // 对应的表
              reftableid: 23051, // 对应的表ID
              pid: '',
              statsize: -1,
              valuedata: '', // 这个是选择的值
            },
            oneObj: e => {
              this.formConfig.formValue.PS_C_CATEGORY_ONE_ID = e.pid
            },
          },
          {
            style: 'dropSelect',
            width: '8',
            itemdata: {
              col: 2,
              colid: 1700847926, // 字段id
              colname: 'PS_C_CATEGORY_ID', // 当前字段的名称 用来显示的
              display: 'text', // 显示什么类型，例如xml表示弹窗多选加导入功能，mrp表示下拉多选
              fkdisplay: 'drp', // 外键关联类型
              fkdesc: '品牌',
              inputname: 'PS_C_PRO:ENAME', // 这个是做中文类型的模糊查询字段，例如ENAME
              isfk: true, // 是否有fk键
              isnotnull: false, // 是否必填
              name: t('商品类目(二级)'),
              readonly: false, // 是否可编辑，对应input   readonly属性
              reftable: 'PS_C_PRO', // 对应的表
              reftableid: 23051, // 对应的表ID
              pid: '',
              statsize: -1,
              valuedata: '', // 这个是选择的值
              /* refcolval: {
                fixcolumn: 'PARENT_ID',
                expre: 'equal',
                srccol: 'PS_C_CATEGORY_ONE_ID'
              } */
            },
            oneObj: e => {
              this.formConfig.formValue.PS_C_CATEGORY_ID = e.pid
            },
          },
          {
            style: 'dropSelect',
            width: '8',
            itemdata: {
              col: 2,
              colid: 1700861922, // 字段id
              colname: 'PS_C_CATEGORY_THREE_ID', // 当前字段的名称 用来显示的
              display: 'text', // 显示什么类型，例如xml表示弹窗多选加导入功能，mrp表示下拉多选
              fkdisplay: 'drp', // 外键关联类型
              fkdesc: '品牌',
              inputname: 'PS_C_PRO:ENAME', // 这个是做中文类型的模糊查询字段，例如ENAME
              isfk: true, // 是否有fk键
              isnotnull: false, // 是否必填
              name: t('三级分类'),
              readonly: false, // 是否可编辑，对应input   readonly属性
              reftable: 'PS_C_PRO', // 对应的表
              reftableid: 23051, // 对应的表ID
              pid: '',
              statsize: -1,
              valuedata: '', // 这个是选择的值
              /* refcolval: {
                fixcolumn: 'PARENT_ID',
                expre: 'equal',
                srccol: 'PS_C_CATEGORY_ID'
              } */
            },
            oneObj: e => {
              this.formConfig.formValue.PS_C_CATEGORY_THREE_ID = e.pid
            },
          },
          {
            style: 'select',
            label: t('是否赠品'),
            value: 'IS_GIFT',
            width: '8',
            multiple: true,
            options: [
              { label: t('是'), value: 'Y' },
              { label: t('否'), value: 'N' },
            ],
          },
          {
            style: 'select',
            label: t('是否组合商品'),
            value: 'IS_GROUP',
            width: '8',
            multiple: true,
            options: [
              { label: t('是'), value: 'Y' },
              { label: t('否'), value: 'N' },
            ],
          },
        ],
      }, // 表单配置
      businessButtonConfig: {
        typeAll: 'default', // 按钮统一风格样式
        btnsite: 'right', // 按钮位置 (right , center , left)
        buttons: [
          {
            text: t('查找'),
            type: 'primary',
            btnclick: () => {
              this.request()
            } // 按钮点击事件
          },
          {
            text: t('重置'),
            btnclick: () => {
              $utils.formEmpty(this, 'formConfig')
              this.$refs.categoryName.valuedata = '' // 重置商品品类
              this.request()
            } // 按钮点击事件
          }
        ],
      },
      tableConfigR: {
        pageShow: false,
        indexColumn: true,
        isShowSelection: false,
        loading: false, // 加载
        height: '300', // 表格高度
        border: true, // 是否显示纵向边框
        current: 1, // 当前页
        total: 0, // 设置总条数
        pageSizeOpts: [9999], // 每页条数切换的配置
        pageSize: 9999, // 每页条数
        data: [],
        columns: [
          {
            key: 'IS_DELETE',
            title: t('操作'),
            className: 'IS_DELETE_OP',
            render: (h, params) => h('Button',
              {
                style: {
                  margin: 0
                },
                props: {
                  type: 'text',
                },
                on: {
                  click: () => {
                    this.tableConfigR.loading = true
                    this.tableConfigR.data.splice(params.index, 1)
                    this.tableConfigR.loading = false
                  }
                }
              },
              t('删除')
            )
          },
          {
            title: t('商品SKU'),
            key: 'PS_C_SKU_ECODE',
          },
          {
            title: t('SKU名称'),
            key: 'PS_C_PRO_ENAME',
          },
          {
            title: t('吊牌价'),
            key: 'PRICELIST',
          },
          {
            title: t('销售属性'),
            key: 'SALES_ATTRIBUTE',
            render: (h, params) => {
              if (!params.row.SALES_ATTRIBUTE) return h('span', {}, '')
              let fields = params.row.SALES_ATTRIBUTE.split(';')
              let nodes = fields.map(item => {
                return h('li', {}, [h('span', {}, item)])
              })
              return h('Poptip',
                {
                  props: {
                    placement: 'top',
                    transfer: true,
                    trigger: 'hover',
                    width: '100px'
                  },
                }, [
                  h('div', { class: 'extend-attrs' }, params.row.SALES_ATTRIBUTE),
                  h('div', { slot: 'content' }, [h('div', {}, [h('ul', {}, nodes)])])
                ]
              )
            }
          },
          {
            title: t('国际码'),
            key: 'GBCODE',
          },
          {
            title: t('品牌'),
            key: 'PS_C_BRAND_ID',
          },
          {
            title: t('商品品类'),
            key: 'PS_C_CATEGORY_ID',
          },
        ]
      },
      tableConfig: {
        pageShow: true, // 控制分页是否显示
        btnsShow: true, // 控制操作按钮是否显示
        indexColumn: true,
        // 是否存在多选框
        isShowSelection: true,
        loading: false, // 加载
        height: '300', // 表格高度
        border: true, // 是否显示纵向边框
        current: 1, // 当前页
        total: 0, // 设置总条数
        pageSizeOpts: [50, 100, 150, 200], // 每页条数切换的配置
        pageSize: 50, // 每页条数
        data: [],
        selectionData: [],
        columns: [
          // 表头
          {
            title: t('商品SKU'),
            key: 'PS_C_SKU_ECODE',
          },
          {
            title: t('SKU名称'),
            key: 'PS_C_PRO_ENAME',
          },
          {
            title: t('吊牌价'),
            key: 'PRICELIST',
          },
          {
            title: t('销售属性'),
            key: 'SALES_ATTRIBUTE',
            render: (h, params) => {
              if (!params.row.SALES_ATTRIBUTE) return h('span', {}, '')
              let fields = params.row.SALES_ATTRIBUTE.split(';')
              let nodes = fields.map(item => {
                return h('li', {}, [h('span', {}, item)])
              })
              return h('Poptip',
                {
                  props: {
                    placement: 'top',
                    transfer: true,
                    trigger: 'hover',
                    width: '100px'
                  },
                }, [
                  h('div', { class: 'extend-attrs' }, params.row.SALES_ATTRIBUTE),
                  h('div', { slot: 'content' }, [h('div', {}, [h('ul', {}, nodes)])])
                ]
              )
            }
          },
          {
            title: t('国际码'),
            key: 'GBCODE',
          },
          {
            title: t('品牌'),
            key: 'PS_C_BRAND_ID',
          },
          {
            title: t('商品品类'),
            key: 'PS_C_CATEGORY_ID',
          },
        ]
      }
    };
  },
  mounted() {
    this.onBeforeHandle()
    if (this.init()) return
    this.request()
  },
  methods: {
    toRight() {
      const arr = [...this.tableConfigR.data, ...this.tableConfig.selectionData];
      const uniqueArr = [...new Set(arr.map(JSON.stringify))].map(JSON.parse); // 去重
      this.tableConfigR.data = uniqueArr;
    },
    init() {
      // 显示【币种】表格列 - 拓竹
      const bzCb = () => {
        this.tableConfig.columns.splice(2, 0, {
          title: t('币种'),
          key: 'CP_C_CURRENCY_NAME',
        })
      }
      const hiddenColumn = (colArr) => {
        this.formConfig.formData.forEach(i => {
          let colname = i.value || i.colname || i.itemdata && i.itemdata.colname
          if (colArr.includes(colname)) {
            i.style = ''
          }
          colname == 'PS_C_CATEGORY_ID' && colArr.includes('PS_C_CATEGORY_ONE_ID') && i.style != 'formCompile' && (i.style = '')
        })
      }
      let flag = false
      switch (this.$route.params.customizedModuleName || this.$route.params.tableName) {
        case 'ORDERMANAGEADD': // 零售新增
        case 'PM_C_PROM_ACTI': // 促销
          /**
           * 零售新增、促销
           * 1.【添加商品SKU】弹窗打开默认不刷数据
           * 2. 显示【是否组合商品】表单筛选字段及表格列
           */
          this.tableConfig.columns.push({
            title: t('是否组合商品'),
            key: 'IS_GROUP',
          })
          // this.$route.params.customizedModuleName == 'ORDERMANAGEADD' && bzCb()
          hiddenColumn(['PS_C_CATEGORY_ONE_ID', 'PS_C_CATEGORY_THREE_ID', 'IS_GIFT'])
          flag = true
          break;
        case 'COMBINEDCOMMODITY': // 组合商品
          /**
           * 组合商品
           * 1、默认不加载数据
           * 2、显示【币种】表格列 - 拓竹
           */
          // bzCb()
          hiddenColumn(['PS_C_CATEGORY_ONE_ID', 'PS_C_CATEGORY_THREE_ID', 'IS_GIFT', 'IS_GROUP'])
          flag = true
          break;
        case 'SG_C_PERCENT_STRATEGY': // 百分比分货策略
          const index = this.formConfig.formData.findIndex(i => i.value == 'PS_C_CATEGORY_ID' && i.style == 'formCompile')
          this.formConfig.formData.splice(index, 1)
          hiddenColumn(['IS_GROUP'])
          break;
        default:
          break;
      }
      return flag
    },
    beforeRequestConds(params) {
      const condsCb = () => {
        // 是否组合商品字段值处理
        if (this.formConfig.formValue.hasOwnProperty('IS_GROUP')) {
          let val = this.formConfig.formValue.IS_GROUP
          if (val) {
            if (Array.isArray(val)) {
              if (val.length) {
                params.fixedcolumns.IS_GROUP = val.map(i => `=${i}`)
              } else {
                delete params.fixedcolumns.IS_GROUP
              }
            } else {
              params.fixedcolumns.IS_GROUP = [`=${val}`]
            }
          } else {
            delete params.fixedcolumns.IS_GROUP
          }
        }
      }
      switch (this.$route.params.customizedModuleName) {
        case 'PM_C_PROM_ACTI': // 促销
          condsCb()
          break;
        case 'ORDERMANAGEADD': // 零售新增
        case 'COMBINEDCOMMODITY': // 组合商品
          // 成分商品根据选择的币种进行过滤，展示对应币种的SKU '零售价'
          let CP_C_CURRENCY_ID = ''
          if (this.$route.params.customizedModuleName == 'COMBINEDCOMMODITY') {
            const { tabTableArr, tabConfig } = this.$parent.$parent.$parent
            tabTableArr && tabConfig && (CP_C_CURRENCY_ID = tabTableArr[tabConfig.labelDefaultValue].rule.CP_C_CURRENCY_ID)
          } else {
            condsCb()
            const { formConfig } = this.$parent.$parent
            formConfig && (CP_C_CURRENCY_ID = formConfig.formData.find(i => i.colname == 'CP_C_CURRENCY_ECODE').itemdata.pid)
          }
          if (this.$route.params.customizedModuleName == 'ORDERMANAGEADD') {
            params.fixedcolumns.CP_C_CURRENCY_ID = CP_C_CURRENCY_ID
          }
          params.table = 'PS_C_SKU_GROUP_DIALOG'
          break;
        default:
          break;
      }
      return params
    },
    afterResponse(row, item) {
      switch (this.$route.params.customizedModuleName) {
        case 'ORDERMANAGEADD': // 零售新增
          return {
            ...row,
            PRICELIST: item.PRICE_RETAIL ? item.PRICE_RETAIL.val : '', // 零售价
            CP_C_CURRENCY_ID: item.CP_C_CURRENCY_ID ? item.CP_C_CURRENCY_ID.refobjid : '', // 币种
            CP_C_CURRENCY_NAME: item.CP_C_CURRENCY_ID ? item.CP_C_CURRENCY_ID.val : '', // 币种
          }
        case 'COMBINEDCOMMODITY': // 组合商品
          return {
            ...row,
            CP_C_CURRENCY_ID: item.CP_C_CURRENCY_ID ? item.CP_C_CURRENCY_ID.refobjid : '', // 币种
            CP_C_CURRENCY_NAME: item.CP_C_CURRENCY_ID ? item.CP_C_CURRENCY_ID.val : '', // 币种
          }
        default:
          return row
      }
    },
    // 查找成分商品
    request() {
      this.tableConfig.loading = true
      // 本页面只展示 商品SKU表中【可用】= “是”且【是否组合商品】= “否” 的数据，零售新增除外-【可用】= “是”
      const self = this;
      let params = {
        table: 'PS_C_SKU_GROUP_DIALOG',
        fixedcolumns: {
          IS_GROUP: ["=N"],
          ISACTIVE: ["=Y"]
        },
        startindex: (this.tableConfig.current -1) * this.tableConfig.pageSize,
        range: this.tableConfig.pageSize,
        column_include_uicontroller: true,
        isolr: false
      }

      // 其它筛选条件处理
      const { valuedata, category } = this.$refs.hasOwnProperty('categoryName') && this.$refs.categoryName || {}
      if (!!valuedata) {
        params.fixedcolumns.PS_C_CATEGORY_ID = [category.id]
      }
      for (let key in this.formConfig.formValue) {
        const val = this.formConfig.formValue[key]
        if (val.length) {
          params.fixedcolumns[key] = val
        }
      }

      params = this.beforeRequestConds(params)

      const formdata = new FormData()
      formdata.append('searchdata', JSON.stringify(params))
      self.service.common.QueryList(formdata).then((res) => {
        this.tableConfig.loading = false
        if (res.data.code === 0) {
          const data = res.data.datas.row || [];
          const arr = []; // 展示的数据
          data.forEach((item) => {
            // 获取想要展示的
            let boolean = new Map([
              ['是', 'Y'],
              ['否', 'N'],
            ])

            // ID、SKU名称、颜色、尺码、销售属性、国际码、品牌、商品品类、是否赠品、是否组合商品、条码、SPU编码、零售价
            let colnameArr = [
              'ID', 'PS_C_PRO_ENAME', 'PS_C_SPEC1OBJ_ID', 'PS_C_SPEC2OBJ_ID', 'SALES_ATTRIBUTE',
              'GBCODE', 'PS_C_BRAND_ID', 'PS_C_CATEGORY_ID', 'IS_GIFT', 'IS_GROUP',
              ['PS_C_SKU_ECODE', 'ECODE'], ['PS_C_PRO_ECODE', 'PS_C_PRO_ID'],
              ['PRICELIST', 'PRICE_LIST'],
            ]
            let row = {
              RATIO: 0, // 占比
              NUM: 1,
            }
            colnameArr.forEach(colname => {
              if (typeof colname == 'string') {
                row[colname] = item[colname] ? item[colname].val : ''
              } else {
                const [newK, oldK] = colname
                row[newK] = item[oldK] ? item[oldK].val : ''
              }
            })
            row = this.afterResponse(row, item) // 其它反参处理
            arr.push(row);
          });
          self.tableConfig.data = arr
          self.tableConfig.total = res.data.datas.totalRowCount
          if (res.data.code != 0) {
            this.$Message.warning(res.data.message);
          }
        }
      });
    },
    submit() {
      if (!this.tableConfigR.data.length) {
        this.$Message.error('请先添加数据至右边表格！')
        return
      }
      this.$emit('on-ok', this.tableConfigR.data)
    },
    // 回调-用于扩展组件（eg: 零售列表/详情-【添加赠品】弹窗增加“数量”列)
    onBeforeHandle () {
      this.$nextTick(() => {
        if (this.$listeners['on-before-handle']) {
          this.$emit('on-before-handle')
        }
      })
    },
    // 选中某一项时触发
    onSelect(selection) {
      this.tableConfig.selectionData = selection;
    },
    // 取消选中某一项时触发
    onSelectCancel(selection) {
      this.tableConfig.selectionData = selection;
    },
    // 点击全选时触发
    onSelectAll(selection) {
      this.tableConfig.selectionData = selection;
    },
    // 点击取消全选时触发
    onSelectAllCancel(selection) {
      this.tableConfig.selectionData = selection;
    },
    // 分页change 事件
    pageChange(val) {
      this.tableConfig.current = val;
      this.request();
    },
    // 切换分页条数
    pageSizeChange(val) {
      this.tableConfig.pageSize = val;
      this.request();
    },
  }
};
